module.exports = __webpack_public_path__ + "img/image_04.83fecdac.png";